// extracted by mini-css-extract-plugin
export var actionIcon = "_v1-0";